import { v4 as uuidv4 } from 'uuid';
import { store } from '@store/online/index';
import { updateUserAuth } from '@store/online/auth/authSlice';

export const setBrowserSessionId = () => {
  const uniqueId = uuidv4();
  const guestSessionId = store.getState().auth.guestSessionId;

  if (!guestSessionId) {
    store.dispatch(updateUserAuth({ guestSessionId: uniqueId }));
  }
};
